import { Controller } from "@hotwired/stimulus";
import { Html5Qrcode } from "html5-qrcode";

export default class extends Controller {
  static targets = [
    "inputSection", 
    "changeSection", 
    "textInput", 
    "qrSection", 
    "qrToggle", 
    "qrUpload", 
    "qrFileInput"
  ];
  
  static values = {
    showSecrets: Boolean,
    hasPrevalue: Boolean
  };

  connect() {
    this.isActivelyEditing = false;
    this.isOtpEdit = false;
    this.qrData = "";
    this.qrScannerSetup = false;
    
    this.updateDisplayState();
  }

  formatInput(event) {
    const input = event.target;
    const formattedValue = input.value.toUpperCase().replace(/\s/g, '');

    if (!this.isActivelyEditing && !this.showSecretsValue && this.hasPrevalueValue) {
      this.textInputTarget.value = '';
    } else {
      input.value = formattedValue;
    }
    
    this.isActivelyEditing = true;
  }

  preventSpace(event) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  startEditing() {
    if (!this.showSecretsValue && this.hasPrevalueValue) {
      this.textInputTarget.value = '';
    }
    this.isActivelyEditing = true;
  }

  clear() {
    this.textInputTarget.value = '';
  }

  enableEdit() {
    this.isOtpEdit = true;
    this.updateDisplayState();
    
    this.textInputTarget.focus();
  }

  toggleQrUpload() {
    const isHidden = this.qrUploadTarget.classList.contains('hidden');
    this.qrUploadTarget.classList.toggle('hidden', !isHidden);
    this.qrToggleTarget.classList.toggle('hidden', isHidden);
    
    if (isHidden) {
      this.setupQrScanner();
    }
  }
  
  setupQrScanner() {
    if (this.qrScannerSetup) return;
    
    const html5QrCode = new Html5Qrcode(this.qrFileInputTarget.id);
    
    this.qrFileInputTarget.addEventListener('change', (e) => {
      if (e.target.files.length === 0) return;
      
      const file = e.target.files[0];
      html5QrCode.scanFile(file, true)
        .then(decodedText => {
          this.qrData = decodedText;
        })
        .catch(err => {
          console.error('Error scanning file:', err);
        });
    });
    
    this.qrScannerSetup = true;
  }

  scanQrCode() {
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    const url = this.qrData;
    const params = {};
    let match;
    
    while ((match = regex.exec(url))) {
      params[match[1]] = match[2];
    }
    
    if (params.secret) {
      const secret = params.secret.toUpperCase();
      this.textInputTarget.value = secret;
    } else {
      alert("Could not extract OTP secret!");
    }
  }

  updateDisplayState() {
    const shouldShowInput = !this.hasPrevalueValue || this.isOtpEdit || this.showSecretsValue;
    const shouldShowChangeButton = this.hasPrevalueValue && !this.isOtpEdit && !this.showSecretsValue;
    const shouldShowQrSection = !this.hasPrevalueValue || this.isOtpEdit || this.showSecretsValue;

    this.inputSectionTarget.classList.toggle('hidden', !shouldShowInput);
    this.changeSectionTarget.classList.toggle('hidden', !shouldShowChangeButton);
    this.qrSectionTarget.classList.toggle('hidden', !shouldShowQrSection);

    if (shouldShowQrSection) {
      this.qrToggleTarget.classList.remove('hidden');
      this.qrUploadTarget.classList.add('hidden');
    }

    // Disabled fields are not submitted, so we do not send otp_secret: "" when the secret
    // is intentionally hidden (would clear the stored OTP on save).
    this.textInputTarget.disabled = !shouldShowInput;

    const shouldShowValue = this.isActivelyEditing || this.showSecretsValue || !this.hasPrevalueValue;
    if (!shouldShowValue && this.hasPrevalueValue) {
      this.textInputTarget.value = '';
    }
  }
}
